import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import BlogIndex from './pages/blog/BlogIndex';
import RekordboxXmlPost from './pages/blog/RekordboxXmlKillingYourLibrary';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/rekordbox-xml-is-killing-your-library" element={<RekordboxXmlPost />} />
    </Routes>
  </BrowserRouter>
);
